import { ValidatedField } from "./ValidatedField";
import { PLACEHOLDERS, formatIbanForDisplay, validateIban, ibanTippen } from "../validation";
import { useBankAusIban } from "./useBankAusIban";
import type { BankTreffer } from "./bankleitzahlen";

/**
 * IBAN-Feld: gruppierte Anzeige (4er) schon beim Tippen, mod-97-Validierung
 * (ibantools) und — sobald die IBAN eine deutsche Bankleitzahl enthält — die
 * Meldung der zugehörigen Bank über `onBankErkannt`. Der Aufrufer entscheidet,
 * ob er BIC und Institut übernimmt; ein bereits gefülltes Feld soll er nicht
 * überschreiben (Muster: SteuernummerInput → Finanzamt).
 */
export function IbanInput({
  label,
  name,
  value,
  onChange,
  required,
  onBankErkannt,
}: {
  label: string;
  name: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  onBankErkannt?: (bank: BankTreffer) => void;
}) {
  // Beim Tippen prüfen, nicht über den Wert — ein vorbefülltes Feld (Akte,
  // Umwandeln eines Kontakts) darf nichts von selbst eintragen.
  const bankPruefen = useBankAusIban(onBankErkannt);
  return (
    <ValidatedField
      label={label}
      name={name}
      value={value}
      onChange={(v) => {
        onChange(v);
        bankPruefen(v);
      }}
      required={required}
      placeholder={PLACEHOLDERS.iban}
      formatOnType={ibanTippen}
      normalizeOnBlur={formatIbanForDisplay}
      validate={validateIban}
    />
  );
}

export default IbanInput;
